import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles'
import { MixpanelProvider } from 'react-mixpanel-browser'

import { theme, GlobalStyles } from '@homeviews/styles'
import { UserGuidingInit } from './UserGuidingInit'
import Routes from './Routes'

export function App() {
  return (
    <MixpanelProvider token={process.env.NX_REACT_APP_MIXPANEL_TOKEN} config={{ api_host: process.env.NX_REACT_APP_MIXPANEL_API_HOST }}>
      <UserGuidingInit />
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <GlobalStyles />
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </MuiThemeProvider>
      </StylesProvider>
    </MixpanelProvider>
  )
}

export default App
